// Modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorRoutingModule } from './error-routing.module';
import { ErrorComponent } from './error.component';
import { ErrorModuleNotLicensed } from './pages/error-module-not-licensed/error-module-not-licensed.component';
import { ErrorPageNotFoundComponent } from './pages/error-page-not-found/error-page-not-found.component';
import { ErrorPaymentComponent } from './pages/error-payment/error-payment.component';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';

@NgModule({
  declarations: [
    ErrorComponent,
    ErrorPageNotFoundComponent,
    ErrorModuleNotLicensed,
    ErrorPaymentComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatCardModule,
    ErrorRoutingModule
  ]
})
export class ErrorModule {
}
